import mongoose from 'mongoose';
import schema, { IModerationLogDocument } from '../schemas/moderation-logs';

const ModerationLog = (mongoose.models.ModerationLog ||
  mongoose.model<IModerationLogDocument>('ModerationLog', schema)) as mongoose.Model<
  IModerationLogDocument
>;

export default ModerationLog;
